import Registered from 'Components/Guards/HumanResources/Registered';

export default {
    'hr-registered': Registered
};
